import NmsTradePage from './NmsTradePage';
export { NmsTradePage };
export default NmsTradePage;
